import { render } from "./TabPlantDetailsPlot.vue?vue&type=template&id=37c7aedd&scoped=true"
import script from "./TabPlantDetailsPlot.vue?vue&type=script&lang=js"
export * from "./TabPlantDetailsPlot.vue?vue&type=script&lang=js"

import "./TabPlantDetailsPlot.vue?vue&type=style&index=0&id=37c7aedd&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c7aedd"]])

export default __exports__